import { j as e, a as r } from "../../../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import c from "../../../../string-table.js";
import "@ionic/react";
import "../../../../../FeatureFlagProvider-BgPZZ37K.js";
import "react";
import "../../../../../react-paginate-Lh5zQzpz.js";
import { Section as i } from "../Section/Section.js";
import "../../../LoadingInterstitial/LoadingInterstitial.js";
import "../../../../contexts/DesignSystemProvider/DesignSystemProvider.js";
import '../../../../../css/Feedback.css';const l = "_quote_86dvx_1", m = "_quoteContent_86dvx_8", d = "_schoolName_86dvx_15", _ = "_noFeedback_86dvx_20", o = {
  quote: l,
  quoteContent: m,
  schoolName: d,
  noFeedback: _
};
function x(s) {
  const {
    feedbacks: t
  } = s;
  return /* @__PURE__ */ e(i, {
    title: c("SUB_PROFILE_FEEDBACK_FROM_SCHOOLS_HEADER"),
    children: /* @__PURE__ */ e("div", {
      children: t && t.length > 0 ? t.map((n, a) => /* @__PURE__ */ e("blockquote", {
        className: o.quote,
        children: /* @__PURE__ */ r("div", {
          className: o.quoteContent,
          children: [/* @__PURE__ */ e("p", {
            style: {
              margin: 0
            },
            children: /* @__PURE__ */ e("span", {
              children: /* @__PURE__ */ e("q", {
                children: /* @__PURE__ */ e("i", {
                  children: n.content
                })
              })
            })
          }), /* @__PURE__ */ e("footer", {
            className: o.schoolName,
            children: `- ${n.schoolName}`
          })]
        })
      }, `${n.schoolName}-${a}`)) : /* @__PURE__ */ e("span", {
        className: o.noFeedback,
        children: c("SUB_PROFILE_NO_INFORMATION")
      })
    })
  });
}
export {
  x as Feedback
};
